<template>
  <div class="navbar">
    <t-menu theme="light" expandMutex :defaultExpanded="expanded" height="550px" :collapsed="collapsed">
      <t-submenu v-for="item in classificationList" :key="item.id" :title="item.name" :value="item.id"
        class="firstSubmenu">

        <span v-for="secondItem in item.children" :key="secondItem.id" :title="secondItem.name">
          <router-link v-if="secondItem.remark" :key="secondItem.id"
            :to="secondItem.remark + '?ification=' + secondItem.id"><t-menu-item :value="secondItem.id"
              class="secondItem">{{
                secondItem.name }}</t-menu-item></router-link>
          <t-submenu v-else :title="secondItem.name" :value="secondItem.id" class="secondSubmenu">
            <span v-for="thirdItem in secondItem.children" :key="thirdItem.id" :title="thirdItem.name">
              <router-link v-if="thirdItem.remark" :key="thirdItem.id"
                :to="thirdItem.remark + '?ification=' + thirdItem.id">
                <t-menu-item :value="thirdItem.id">{{ thirdItem.name
                  }}</t-menu-item>
              </router-link>
              <t-submenu v-else :title="thirdItem.name" :value="thirdItem.id" class="thirdSubmenu">
                <span v-for="fourthItem in thirdItem.children" :key="fourthItem.id" :title="fourthItem.name">
                  <router-link v-if="fourthItem.remark" :key="fourthItem.id"
                    :to="fourthItem.remark + '?ification=' + fourthItem.id">
                    <t-menu-item :value="fourthItem.id" class="fourth-menu-item">{{ fourthItem.name
                      }}</t-menu-item>
                  </router-link>
                </span>
              </t-submenu>
            </span>

          </t-submenu>
        </span>
      </t-submenu>


    </t-menu>
  </div>
</template>

<script>

import { listClassification } from "@/api/classification";

export default {
  // eslint-disable-next-line vue/multi-word-component-names
  name: 'Navbar',
  data() {
    return {
      expanded: [],
      classificationList: [],
      disabled: true,
      collapsed: false,

    };
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      listClassification(this.queryParams).then(response => {
        this.classificationList = this.handleTree(response.data, "id", "parentId");
        console.log(this.classificationList)
      });
    },
    changeCollapsed() {
      this.collapsed = !this.collapsed;
    }
  }
}
</script>

<style lang="scss" scoped></style>

<style lang="less">
.navbar {
  height: calc(100vh - 100px);
  position: sticky;
  top: 80px;
  z-index: 1000;
  background: #fff;
  border: 1px solid #e3e6ea;

}

.t-menu {
  scrollbar-width: none;
}

.t-menu::-webkit-scrollbar {
  display: none;
}

.t-default-menu__inner .t-menu--scroll {
  padding: 16px 0px 16px 16px !important;
  // overflow: visible !important;
}

.t-default-menu .t-menu__item.t-is-opened {
  margin: 0 !important;
  font-family: "Regular";
}

.t-menu__item-spacer {
  border: 1px solid #DADDE1 !important;
  height: 40px !important;
}



.t-default-menu .t-menu__item {
  width: 200px;
}

.t-default-menu .t-menu__sub a {
  text-decoration: none;
}

//.firstSubmenu {
//  .t-menu__item:first-child {
//    padding-left: 10px;
// }
//}

.secondSubmenu>.t-menu__item {

  padding-left: 30px !important;


}

.secondItem {
  padding-left: 30px !important;
}

.thirdItem {
  padding-left: 60px !important;
}

.firstSubmenu>.t-menu__sub .t-menu__item {
  border-left: 1px solid #DADDE1;
  border-bottom: 1px solid #DADDE1;
  border-right: 1px solid #DADDE1;
  margin: 0 !important;
  font-family: "Regular";
}

.t-default-menu .t-menu__item {
  margin: 0 !important;
  border-radius: 0 !important;
  font-family: "Regular";
}

.t-default-menu .t-menu__item.t-is-opened {
  margin: 0;
  border-radius: 0 !important;
}

.t-default-menu .t-menu__sub .t-menu__item {
  // padding-left:16px !important
}


.t-submenu {
  margin-top: 20px !important;

  // margin-bottom: 0px !important;
  &:first-child {
    margin-top: 0px !important;
  }
}

.secondSubmenu {
  margin-top: 0px !important;
  // border-left:1px solid #DADDE1 !important;
  // border-bottom:1px solid #DADDE1 !important;
  // border-right:1px solid #DADDE1 !important;
  border-top: 0;
  margin-bottom: 0 !important
}


.thirdSubmenu {
  margin-top: 0px !important;
  // border-left:1px solid #DADDE1 !important;
  // border-bottom:1px solid #DADDE1 !important;
  // border-right:1px solid #DADDE1 !important;
  border-top: 0;
  margin-bottom: 0 !important
}

//.secondSubmenu {
//  .t-menu__item:first-child {
//    padding-left: 20px;
//  }
//}

.secondSubmenu>.t-menu__item {
  border-top: 0 !important;
}

.firstSubmenu>.t-menu__item .t-fake-arrow {
  display: none;
}

.secondSubmenu>.t-menu__item .t-fake-arrow {
  display: none;
}

.firstSubmenu>.t-menu__item-spacer--right::before {
  background: url('@/assets/icon/button_cleaner-2.svg');
  right: 10px !important;
  width: 24px !important;
  height: 24px !important;
  position: absolute !important;
  top: 7px !important;
  // transition:all 0.3s ease-in-out 0s;
}

.firstSubmenu>.t-is-opened::before {
  background: url('@/assets/icon/button_cleaner-1.svg');
  right: 10px !important;
  width: 24px !important;
  height: 24px !important;
  position: absolute !important;
  top: 7px !important;
  // transition:all 0.3s ease-in-out 0s;
}

.secondSubmenu>.t-menu__item-spacer--right::before {
  background: url('@/assets/icon/button_cleaner-4.svg');
  right: 10px !important;
  width: 24px !important;
  height: 24px !important;
  position: absolute !important;
  top: 7px !important;
  transition: all 0.2s ease-in-out 0s;
}

.secondSubmenu>.t-is-opened::before {
  background: url('@/assets/icon/button_cleaner-4.svg');
  right: 10px !important;
  width: 24px !important;
  height: 24px !important;
  position: absolute !important;
  top: 7px !important;
  transform: scaleY(-1);
  transition: all 0.2s ease-in-out 0s;
}

.secondSubmenu>.t-is-opened::before .mystop {
  stop-color: red;
}

.thirdSubmenu {
  .t-menu__item {
    padding-left: 40px !important;
  }

}

.fourth-menu-item {
  .t-menu__content {
    padding-left: 10px !important;
  }
}
</style>
